import firebase from 'firebase/app'
import 'firebase/firestore';
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/database'
import functions from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCd7dCRwIUKssIya4Zulf7HuTQvOgpi4Fs",
  authDomain: "snaggingapp-72f9c.firebaseapp.com",
  databaseURL: "https://snaggingapp-72f9c.firebaseio.com",
  projectId: "snaggingapp-72f9c",
  storageBucket: "snaggingapp-72f9c.appspot.com",
  messagingSenderId: "377070186907",
  appId: "1:377070186907:web:542e5975c627708515713e",
  measurementId: "G-NV8GG5LGNW"
};

firebase.initializeApp(firebaseConfig);
const storage = firebase.storage();
const cloudFunction = firebase.functions();


export { storage, cloudFunction, firebase as default };
  //firebase.firestore().settings({ timestampsInSnapshots: true });